<template>
  <ListPage tabName="assigned"></ListPage>
</template>
<script>
import ListPage from "../Component/ListPage";
export default {
  components: {
    ListPage
  }
};
</script>
